import React from 'react';
import PropTypes from 'prop-types';

import { useResponsive } from '../../hooks';
import FiltersIcon from '../../../assets/filters-icon.svg';
import Button from './Button';

const FiltersButton = ({
  anyFiltersSelected,
  onClick,
}) => {
  const { isDesktop } = useResponsive();

  return (
    <Button
      value={t('button.filters', { ns: i18next.Namespace.COMMON })}
      variant="secondary"
      color={anyFiltersSelected ? 'gold' : 'red'}
      onClick={onClick}
      iconAsComponent={<FiltersIcon />}
      extraStyles={isDesktop ? { padding: '12px 24px' } : {}}
    />
  );
};

FiltersButton.propTypes = {
  anyFiltersSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FiltersButton;
